import { render } from "./PretreatmentTable.vue?vue&type=template&id=06f65606&scoped=true"
import script from "./PretreatmentTable.vue?vue&type=script&lang=js"
export * from "./PretreatmentTable.vue?vue&type=script&lang=js"

import "./PretreatmentTable.vue?vue&type=style&index=0&id=06f65606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f65606"]])

export default __exports__